import { ISaveService } from "../../../../../abstractions/services/actions/ISaveService";
import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { MonitoreoBrocaRequest } from "../../../../../modulos/monitoreo/broca/request/MonitoreoBrocaRequest";
import { MonitoreoBrocaResponse } from "../../../../../modulos/monitoreo/broca/response/MonitoreoBrocaResponse";
import { monitoreoBrocaSaveGrpcService } from "../../../../../modulos/monitoreo/broca/services/MonitoreoBrocaSaveGrpcService";
import { BaseFullScreenFormModalRender } from "../../../../base/modal/BaseFullScreenFormModalRender";
import { IFormBodyRender } from "../../../../definitions/form/IFormBodyRender";
import { MonitoreoBrocaFormRender } from "../form/MonitoreoBrocaFormRender";

/** Modal a pantalla completa de creación/edición de un monitoreo de broca.
 *  Hospeda el `MonitoreoBrocaFormRender` y guarda con `monitoreoBrocaSaveGrpcService`. */
export class MonitoreoBrocaModalRender extends BaseFullScreenFormModalRender<
  MonitoreoBrocaRequest,
  MonitoreoBrocaResponse
> {
  protected readonly elementId = "monitoreoBrocaModal";

  protected get title(): string {
    return "Monitoreo Broca";
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().get()?.nombreFinca;
  }

  protected get saveLabel(): string {
    return "Registrar Monitoreo";
  }

  protected getFormBody(): IFormBodyRender {
    return new MonitoreoBrocaFormRender(this._request);
  }

  protected get saveService(): ISaveService<
    MonitoreoBrocaRequest,
    MonitoreoBrocaResponse
  > {
    return monitoreoBrocaSaveGrpcService;
  }
}
